var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-fixed-btn"},[_c('router-link',{attrs:{"to":_vm.$i18nRoute({ name: 'feedback-add' })}},[_c('span',{staticClass:"feedback-icon"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }